import React from 'react'
import styled from 'styled-components'
import { Box, Typography, Button, Container } from '@mui/material'
import { brands } from 'utils/constant'
import { translate } from 'utils/intl/helper'
import { KEYS } from 'utils/intl/constant'

// Import logos
import { ReactComponent as CarrierLogo } from 'image/carrierLogo.svg'
import { ReactComponent as CiatLogo } from 'image/ciat-logo.svg'
import ViessmannLogoPng from 'image/viessmannLogo.png'

import { useAppSelector } from '../store/hooks'

const StyledContainer = styled(Container)`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    text-align: center;
    background-color: #f8f9fa;
`

const Title = styled(Typography)`
    margin-bottom: 16px;
    font-weight: 600;
    color: #2c3e50;
`

const Subtitle = styled(Typography)`
    margin-bottom: 48px;
    color: #6c757d;
`

const ButtonContainer = styled(Box)`
    display: flex;
    gap: 32px;
    margin-top: 32px;
    flex-wrap: wrap;
    justify-content: center;

    @media (max-width: 768px) {
        flex-direction: column;
        gap: 16px;
        width: 100%;
        max-width: 300px;
    }
`

const BrandButton = styled(Button)`
    min-width: 180px;
    height: 120px;
    padding: 16px;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
    }

    &.carrier {
        background-color: #152e70;
        color: white;

        &:hover {
            background-color: #0f1f4f;
        }
    }

    &.ciat {
        background-color: #e40e12;
        color: white;

        &:hover {
            background-color: #c00c10;
        }
    }

    &.viessmann {
        background-color: #cccccc;
        color: #7d7d7d;

        &:hover {
            background-color: #aaaaaa;
        }
    }
`

const StyledCarrierLogo = styled(CarrierLogo)`
    height: 60px;
    width: auto;
    fill: currentColor;
`

const StyledCiatLogo = styled(CiatLogo)`
    height: 60px;
    width: auto;
    fill: currentColor;
`

const StyledViessmannImg = styled.img`
    height: 60px;
    width: auto;
    fill: currentColor;
`

const BrandSelection: React.FC = () => {
    const handleBrandSelect = (brand: string) => {
        window.location.href = `/${brand}`
    }

    const brandData = [
        {
            key: brands.CARRIER,
            logo: <StyledCarrierLogo />,
            className: 'carrier',
        },
        {
            key: brands.CIAT,
            logo: <StyledCiatLogo />,
            className: 'ciat',
        },
        {
            key: brands.VIESSMANN,
            logo: <StyledViessmannImg src={ViessmannLogoPng} alt='Viessmann Logo' />,
            className: 'viessmann',
        },
    ]

    const intl = useAppSelector((state) => state.ui.intl)

    return (
        <StyledContainer maxWidth='md'>
            <Title variant='h2'> {translate(intl, KEYS.UI_WELCOME_TITLE)}</Title>
            <Subtitle variant='h5'> {translate(intl, KEYS.UI_BRAND_SELECTION_SUBTITLE)}</Subtitle>
            <ButtonContainer>
                {brandData.map(({ key, logo, className }) => (
                    <BrandButton
                        key={key}
                        className={className}
                        variant='contained'
                        onClick={() => handleBrandSelect(key)}
                        size='large'>
                        {logo}
                    </BrandButton>
                ))}
            </ButtonContainer>
        </StyledContainer>
    )
}

export default BrandSelection
